const ICON_GROUPS = [
  {
    src: '/images/site/ror.svg',
    keywords: ['kylkopparrör', 'copper tubes', 'rör', 'tubes']
  },
  {
    src: '/images/site/kanaler.svg',
    keywords: ['kanaler', 'ducts', 'duct', 'kanal']
  },
  {
    src: '/images/site/konsoler.svg',
    keywords: ['konsoler', 'brackets']
  },
  {
    src: '/images/site/tillbehor.svg',
    keywords: ['värmepumpstillbehör', 'heat pump accessories', 'tillbehör', 'heating pump accesories', 'heating pump']
  },
  {
    src: '/images/site/verktyg.svg',
    keywords: ['verktyg', 'tools']
  },
  {
    src: '/images/site/el-tillbehor.svg',
    keywords: ['el & eltillbehör', 'electricity and electricity tools', 'el', 'electricity']
  },
  {
    src: '/images/site/kondensvatten-pumpar.svg',
    keywords: ['kondensvatten & pumpar', 'condensation water and pumps', 'pumpar', 'pumps', 'kondensvatten', 'condensation']
  },
  {
    src: '/images/site/tillbehor-service.svg',
    keywords: ['service & underhåll', 'service and maintenance', 'service', 'underhåll', 'maintenance']
  }
];

export function getCategoryIcon(categoryName) {
  if (!categoryName) return null;

  const normalizedName = categoryName.toLowerCase().trim();

  // Hitta den grupp där något av nyckelorden matchar namnet
  const match = ICON_GROUPS.find((group) => group.keywords.some((keyword) => normalizedName.includes(keyword)));

  return match ? match.src : '/images/site/default.svg';
}

export const categoryIconMapping = {
  'service & underhåll': '/images/site/tillbehor-service.svg',
  'service and maintenance': '/images/site/tillbehor-service.svg'
};
